import { AfnamegroepI, DeelnemerI, DeelnemerInputModel } from '@models/deelnemer.model';
import { DeelnemerPlanningenDTO } from '@models/deelnemer-planning.model';
import { PlanningInputModelDTO } from '@models/planning.model';
import { ProductKey } from '@models/startcode.model';


export namespace DeelnemersActions {
  export class loadRapportenAvailable {
    static readonly type = '[Deelnemers] Load Rapporten Available';
  }

  export class putAntwoordbladNummers {
    static readonly type = '[Deelnemers] put Antwoordbladen Nummers';

    constructor(public payload: DeelnemerI[]) {
    }
  }

  export class LoadDeelnemersSuccess {
    static readonly type = '[Deelnemers] Load Deelnemers Success';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(public payload: any) {
    }
  }

  export class LoadDeelnemersFailure {
    static readonly type = '[Deelnemers] Load Deelnemers Failure';

    constructor(public payload: string) {
    }
  }

  export class LoadDeelnemers {
    static readonly type = '[Deelnemers] Load Deelnemers';

    constructor(public OnderwijsLocatieId: string, public forceReload: boolean, public productKeys?: ProductKey[]) {
    }
  }

  export class LoadDeelnemersWithStartcodes {
    static readonly type = '[Deelnemers] Load Deelnemers With Startcodes';

    constructor(public OnderwijsLocatieId: string) {
    }
  }

  export class LoadDeelnemerPlanningenSuccess {
    static readonly type = '[Deelnemers] Load DeelnemerPlanningen Success';

    constructor(public payload: DeelnemerPlanningenDTO[]) {
    }
  }

  export class LoadDeelnemerPlanningenFailure {
    static readonly type = '[Deelnemers] Load DeelnemerPlanningen Failure';

    constructor(public payload: string) {
    }
  }

  export class CreateStartcodesForDeelnemers {
    static readonly type = '[Deelnemers] Create StartcodesForDeelnemers';

    constructor(
      public deelnemerIds: string[],
      public productKeys?: ProductKey[],
      public suppressToast = false,
    ) {
    }
  }

  export class CreateStartcodesForDeelnemersOnIds {
    static readonly type = '[Deelnemers] Create StartcodesForDeelnemers OnIds';

    constructor(public persoonIds: string[], public productKeys?: ProductKey[]) {
    }
  }

  export class CreateStartcodes {
    static readonly type = '[Deelnemers] Create Startcodes';

    constructor(public productKeys?: ProductKey[]) {
    }
  }

  export class ReadDeelnemerStartcodes {
    static readonly type = '[Deelnemers] Load DeelnemerStartcodes on OnderwijsLocatieId';

    constructor(public productKeys?: ProductKey[]) {
    }
  }

  export class DeleteStartcodes {
    static readonly type = '[Deelnemers] Delete Startcodes';
  }

  export class PrintStartcodes {
    static readonly type = '[Deelnemers] print Startcodes';
  }

  export class PrintStartcodesDone {
    static readonly type = '[Deelnemers] print Startcodes Done';
  }

  export class SelectDeelnemer {
    static readonly type = '[Deelnemers] Select Deelnemer';

    constructor(public payload: DeelnemerI) {
    }
  }

  export class SelectDeelnemerOnId {
    static readonly type = '[Deelnemers] Select Deelnemer On Id';

    constructor(public payload: string) {
    }
  }

  export class DeselectDeelnemer {
    static readonly type = '[Deelnemers] Deselect Deelnemer';
  }

  export class SelectGroep {
    static readonly type = '[Deelnemers] Select Groep';

    constructor(public payload: AfnamegroepI) {
    }
  }

  export class DeselectGroep {
    static readonly type = '[Deelnemers] Deselect Groep';
  }

  export class CreateDeelnemer {
    static readonly type = '[Deelnemers] Create Deelnemer';

    constructor(public onderwijsLocatieId: string, public deelnemerInput: DeelnemerInputModel) {
    }
  }

  export class ReadDeelnemer {
    static readonly type = '[Deelnemers] Read Deelnemer';

    constructor(public OnderwijsLocatieId: string, public persoonId: string) {
    }
  }

  export class UpdateDeelnemer {
    static readonly type = '[Deelnemers] Update Deelnemer';

    constructor(
      public OnderwijsLocatieId: string,
      public persoonId: string,
      public deelnemerInput: DeelnemerInputModel,
    ) {
    }
  }

  export class DeleteDeelnemer {
    static readonly type = '[Deelnemers] Delete Deelnemer';

    constructor(public OnderwijsLocatieId: string, public deelnemer: DeelnemerI) {
    }
  }

  export class UpdateSchooladvies {
    static readonly type = '[Deelnemers] Update Schooladvies';

    constructor(public OnderwijsLocatieId: string, public persoonId: string, public schooladviesId: number) {
    }
  }

  export class AddSelectedDeelnemersId {
    static readonly type = '[Deelnemers] Add Selected Deelnemer';

    constructor(public persoonId: string) {
    }
  }

  export class SetSelectedDeelnemersIds {
    static readonly type = '[Deelnemers] Set Selected Deelnemers Ids';

    constructor(public persoonIds: string[]) {
    }
  }

  export class RemoveSelectedDeelnemersId {
    static readonly type = '[Deelnemers] Remove Selected Deelnemer';

    constructor(public persoonId: string) {
    }
  }

  export class RemoveAllSelectedDeelnemersIds {
    static readonly type = '[Deelnemers] Remove All Selected Deelnemers Ids';
  }

  export class UpdatePlanningen {
    static readonly type = '[Deelnemers] Update Planningen';

    constructor(public planningen: PlanningInputModelDTO[], public inhaalToets: boolean) {
    }
  }
}
